import { NotificationProgrammatic as Notification } from 'buefy';
import store from '@/store';

function queryErrorHandler(err) {
  Notification.open({
    duration: 4000,
    message:
      err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : 'Error on query',
    type: 'is-danger',
    hasIcon: true,
    queue: false,
  });
  if (
    err.response &&
    err.response.status === 401 &&
    err.response.data &&
    err.response.data.error &&
    typeof err.response.data.error === 'string' &&
    err.response.data.error.includes('Invalid token')
  ) {
    // If the token is invalid, we proceed to a logout and redirect to the login page
    store.dispatch('signOut');
  } else {
    // Do nothing for now
  }
}

export default queryErrorHandler;
